import { useState, useEffect } from "react";
import { Grid } from "antd";

const { useBreakpoint } = Grid;

export const useResponsiveWindow = () => {
  const breakpoints = useBreakpoint();
  const [windowSize, setWindowSize] = useState({
    width: typeof window !== "undefined" ? window.innerWidth : 1280,
    height: typeof window !== "undefined" ? window.innerHeight : 720,
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initial call
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return {
    ...windowSize,
    breakpoints,
    isMobile: breakpoints.xs,
    isTablet: breakpoints.sm && !breakpoints.md,
    isSmallScreen: breakpoints.xs || breakpoints.sm,
    isMediumScreen: breakpoints.md || breakpoints.lg,
    isLargeScreen: breakpoints.xl || breakpoints.xxl,
  };
};
